export default __webpack_public_path__ + "static/media/DSC-2.be4e6013.jpg";